import { Color } from '@billy/design-system'

import { Status } from '../../../types/status'

export const statusToDotColor: Record<Status, Color> = {
  error: Color.Red700,
  neutral: Color.Grey300,
  primary: Color.Lavender500,
  success: Color.Green600,
  warning: Color.Yellow400,
}
